import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import * as actions from "../../redux/actions";
import * as statsCalc from "../../components/Statistics/statsCalc";
import statsConfig from "../../config/stats.json";
import { getDailyTimestamp, secsToStr } from "../../tools";

const stateWithBookmarks = {
  currentExercise: {
    183: {
      title: "Odcinek-1, Historia",
      link: "/kurs/szybki-angielski-1/cwiczenia/odcinek-1/historia",
    },
  },
  bookmarks: {
    183: [
      {
        id: 0,
        title: "Odcinek-1, Historia",
        link: "/kurs/szybki-angielski-1/cwiczenia/odcinek-1/historia",
      },
      {
        id: 1,
        title: "Odcinek-3, Drama",
        link: "/kurs/szybki-angielski-1/cwiczenia/odcinek-3/drama",
      },
      {
        id: 2,
        title: "Odcinek-4, Koncert",
        link: "/kurs/szybki-angielski-1/cwiczenia/odcinek-4/koncert",
      },
    ],
  },
};

function Ui(props) {
  const getNotes = () => {
    props.getNotes();
  };

  const logOut = () => {
    props.logOut();
  };

  const triggerCrash1 = () => {
    console.log(window.app.nonexisting.object);
  };

  return (
    <div className="container default-fx">
      <div>
        <h2>Uwierzytelnianie</h2>
        <Button
          variant="contained"
          color="primary"
          component={Link}
          to="/login"
        >
          Logowanie
        </Button>
        <Button variant="contained" onClick={logOut} color="primary">
          Wyloguj
        </Button>
        <Button variant="contained" onClick={props.isLogged} color="primary">
          Is Logged
        </Button>
      </div>
      <div>
        <h2>Config</h2>
        <Button variant="contained" onClick={props.loadConfig} color="primary">
          Load Config
        </Button>
        <Button
          variant="contained"
          onClick={() => props.saveConfig(props.config)}
          color="primary"
        >
          Save Config
        </Button>
        <Button
          variant="contained"
          onClick={() => props.saveConfig({})}
          color="primary"
        >
          Reset Config
        </Button>
      </div>
      <div>
        <h2>userState</h2>
        <Button
          variant="contained"
          onClick={props.getUserState}
          color="primary"
        >
          Load
        </Button>
        <Button
          variant="contained"
          onClick={() => props.saveUserSatate(props.userState)}
          color="primary"
        >
          Save
        </Button>
        <Button
          variant="contained"
          onClick={() => props.saveUserSatate(stateWithBookmarks)}
          color="primary"
        >
          Add Bookmarks
        </Button>
        <Button variant="contained" onClick={props.resetState} color="primary">
          Default State
        </Button>
        <Button variant="contained" onClick={props.emptyState} color="primary">
          Empty State
        </Button>
        <Button
          variant="contained"
          onClick={() => props.delBookmark(0)}
          color="primary"
        >
          Del Bookmark (0)
        </Button>
        <Button
          variant="contained"
          onClick={() =>
            props.addBookmark("Super nowy bookmark - DEFAULT", "/")
          }
          color="primary"
        >
          Add Bookmark
        </Button>
      </div>
      <div>
        <h2>Stats</h2>
        <Button
          variant="contained"
          onClick={() =>
            props.saveUserSatate({ ...props.userState, stats: {} })
          }
          color="primary"
        >
          Reset Stats
        </Button>
        <Button
          variant="contained"
          onClick={() =>
            props.saveUserSatate(clearWeeklyStats(props.userState))
          }
          color="primary"
        >
          Clear weekly stats
        </Button>
        <Button
          variant="contained"
          onClick={() =>
            props.saveUserSatate(createWeeklyStats(props.userState))
          }
          color="primary"
        >
          Create weekly stats
        </Button>
        <Button
          variant="contained"
          onClick={() => consoleWeeklyStats(props.userState)}
          color="primary"
        >
          Console Stats
        </Button>
        <Button
          variant="contained"
          onClick={() =>
            props.saveUserSatate(statsCalc.clearOutdatedData(props.userState))
          }
          color="primary"
        >
          Clean outdated
        </Button>
      </div>
      <div>
        <h2>Crash</h2>
        <Button variant="contained" onClick={triggerCrash1} color="primary">
          Crash 1
        </Button>
      </div>
    </div>
  );
}

function consoleWeeklyStats(userState) {
  const courseId = userState.currentCourseId;
  if (!courseId) return alert("Proszę najpierw wybrać jakiś kurs");
  const dailySeconds = 60 * 60 * 24;
  const today = getDailyTimestamp();
  const times = userState.stats[courseId].times;
  const todayTimes = statsCalc.calcDailyTime(times[today]);
  let weeklyTime = 0;
  for (let i = 0; i < 7; ++i) {
    weeklyTime += statsCalc.calcDailyTime(times[today - dailySeconds * i]);
  }
  // console.log(secsToStr(todayTimes, 'h:mm:ss'), secsToStr(weeklyTime, 'h:mm:ss'))
  Object.keys(times).forEach((timestamp) => {
    const date = new Date(parseInt(timestamp) * 1000);
    // console.log(date.toLocaleDateString())
  });
}

// userState -> stats -> courseId -> times -> timestamp: {... }
function createWeeklyStats(userState) {
  const courseId = userState.currentCourseId;
  if (!courseId) return alert("Proszę najpierw wybrać jakiś kurs");
  const today = getDailyTimestamp();
  const times = {};
  for (let i = 0; i < 15; ++i) {
    const time = today - i * 60 * 60 * 24;
    times[time] = generateStats();
  }
  const newUserState = { ...userState };
  newUserState.stats[courseId].times = times;
  return newUserState;
}

function generateStats() {
  const rnd = () => Math.floor(Math.random() * 2000);
  const times = { ...statsConfig.defaults };
  Object.keys(times).forEach((key) => {
    times[key] = rnd();
  });
  return times;
}

function clearWeeklyStats(userState) {
  const courseId = userState.currentCourseId;
  if (!courseId) return alert("Proszę najpierw wybrać jakiś kurs");
  const newUserState = { ...userState };
  newUserState.stats[courseId].times = {};
  return newUserState;
}

const mapStateToProps = (state) => {
  const { auth, notes, config, messages, userState, tools } = state;
  return { auth, notes, config, messages, userState, tools };
};

export default connect(mapStateToProps, actions)(Ui);
